import { FunctionComponent, useState } from "react";
import Modal from "../../../../../../common/Modal/Modal";
import Label from "../../../../../../Label";
import { Icon } from "../../../../../../Icon";
import "./styles.scss";
import { DetailedCartItem } from "../../../../../../../context/CartContext/CartContext.api.types";
import Button from "../../../../../../common/Button";
import setColorName from "../../../../../../../utils/setColorName";
import classNames from "classnames";
import { useCart } from "../../../../../../../context/CartContext";
import useDevice from "../../../../../../../utils/hooks/useDevice";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  cartDetailedItem: DetailedCartItem;
  getLabels: (cartDetailedItem: DetailedCartItem) => LenghtLabel;
};
const EditItemModal: FunctionComponent<Props> = ({
  isOpen,
  onClose,
  cartDetailedItem,
  getLabels,
}) => {
  const { variation, product, quantity } = cartDetailedItem;

  const [currentQuantity, setCurrentQuantity] = useState<number>(quantity);

  const colorName = setColorName(variation.color);

  const { updateItemQuantity } = useCart();

  const { isMobile } = useDevice();
  const handleClick = (variationId: string, quantity: number) => {
    updateItemQuantity(variationId, quantity);
    onClose();
  };

  const translateColor =
    variation.color === "blanco"
      ? "gold-white"
      : variation.color === "rojo"
      ? "gold-red"
      : variation.color === "amarillo"
      ? "gold-yellow"
      : "silver";

  const labels = getLabels(cartDetailedItem);
  const productDetails = `${labels.cartGaugeLabel} ${variation?.gauge} ${labels.cartLenghtLabel} ${variation?.length} ${labels.unit}`;

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      children={
        <div className="edit-item-modal">
          <header className="edit-item-modal__header">
            <Label tag="h3" className="edit-item-modal__title">
              Editar
            </Label>
            <div onClick={onClose}>
              <Icon
                iconName="close_icon"
                className="edit-item-modal__close-icon"
              />
            </div>
          </header>
          <div className="edit-item-modal__content">
            <div className="edit-item-modal__details">
              <Label
                tag="p"
                variants="body1"
                className="edit-item-modal__details__title"
              >
                {product.title}
              </Label>
              <div className="edit-item-modal__details__description">
                <div
                  className={`edit-item-modal__details__material edit-item-modal__details__material--${translateColor}`}
                />
                <Label tag="p" variants="body2">
                  {colorName}
                </Label>
                <Label tag="p" variants="body2">
                  {productDetails}
                </Label>
              </div>
            </div>
            <div className="edit-item-modal__details__quantity">
              <Label
                tag="p"
                variants={isMobile ? "body2" : "body1"}
                className="edit-item-modal__details__quantity__title"
              >
                Cantidad
              </Label>
              <div className="edit-item-modal__details__quantity__options">
                <span
                  onClick={() => {
                    if (currentQuantity > 1)
                      setCurrentQuantity(currentQuantity - 1);
                  }}
                  className={classNames(
                    "edit-item-modal__details__quantity__options__action",
                    {
                      "edit-item-modal__details__quantity__options__action--disabled":
                        currentQuantity === 1,
                    }
                  )}
                >
                  -
                </span>
                <div className="edit-item-modal__details__quantity__options__value">
                  <span>{currentQuantity}</span>
                </div>
                <span
                  onClick={() => setCurrentQuantity(currentQuantity + 1)}
                  className="edit-item-modal__details__quantity__options__action"
                >
                  +
                </span>
              </div>
            </div>
            <Button
              applyNewSize
              className="edit-item-modal__button"
              onClick={() => handleClick(variation.id, currentQuantity)}
            >
              Modificar
            </Button>
          </div>
        </div>
      }
    />
  );
};

export default EditItemModal;
